// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__PqiKF","empty":"ModalGraph_empty__3IFO1"};